import React, { Component } from 'react';
import Inbox from './Inbox.js';

export default class InboxNotaDinas extends Component {
  render() {
    return (
      <Inbox type='TNDE_NOTA_DINAS'/>
    );
  }
}
